export const PROJECT_ID = 'projectId';
export const PROJECT_TYPE = 'projectType';
export const IMPORT_PROJECT = 'importProject';
export const NOT_IMPORTABLE_REASONS_AS_EXCEPTIONS = 'notImportableReasonsAsExceptions';